import requestStatuses from '@clearscore/constants.request-statuses';

import {
    USERS_INITIATE_RESET_PASSWORD,
    USERS_INITIATE_RESET_PASSWORD_SUCCESS,
    USERS_INITIATE_RESET_PASSWORD_ERROR,
    RESET_PASSWORD_CONFIRMATION_SHOW,
} from './types';

const initialState = {
    status: requestStatuses.INITIAL,
    showResetPasswordConfirmation: false,
};

export default function initiateResetPasswordReducer(state = initialState, action) {
    switch (action.type) {
        case USERS_INITIATE_RESET_PASSWORD:
            return {
                ...state,
                status: requestStatuses.PENDING,
            };
        case USERS_INITIATE_RESET_PASSWORD_SUCCESS:
            return {
                ...state,
                status: requestStatuses.SUCCESS,
            };
        case USERS_INITIATE_RESET_PASSWORD_ERROR:
            return {
                ...state,
                status: requestStatuses.ERROR,
            };
        case RESET_PASSWORD_CONFIRMATION_SHOW:
            return {
                ...state,
                showResetPasswordConfirmation: true,
            };
        default:
            return state;
    }
}
